import { OmniUser } from "@app/shared/src/models";

/**
 * The Terms and Conditions in force, and whether a user has accepted that revision.
 *
 * The file lives in this app's public folder and is the same PDF the main dashboard shows, under
 * the same name — the server records acceptance by file name, so a director who accepted on the
 * dashboard is not asked again here, and vice versa. Revising the terms means a new file name,
 * copied to both apps.
 */
export const LATEST_TERMS_FILE = "terms_03272024.pdf";
export const LATEST_TERMS_PATH = `${process.env.PUBLIC_URL ?? ""}/${LATEST_TERMS_FILE}`;

export const latestTermsAcceptance = (user?: OmniUser) => user?.terms?.find((t) => t.fileName === LATEST_TERMS_FILE);
